import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import "../AFSTool/afs-walkthrough.css";

class ToolsReviewSection extends Component {
	onTitleKeyDown = event => {
		if (event.key !== "Enter" && event.key !== " ") return;
		event.preventDefault();
		this.props.onToggle();
	};

	render() {
		const { title, meta, doneCount, totalCount, isExpanded, onToggle, children } = this.props;
		const isAllDone = totalCount > 0 && doneCount === totalCount;

		return (
			<div className={clsx("afs-review__section", isAllDone && "afs-review__section--passed")}>
				<div
					role="button"
					tabIndex={0}
					aria-expanded={!!isExpanded}
					className="afs-review__section-title afs-review__section-title--clickable"
					onClick={onToggle}
					onKeyDown={this.onTitleKeyDown}
				>
					{isAllDone && <Icon.CheckCircle size={16} color="#4caf50" />}
					<span>{title}</span>
					<span className="afs-review__section-meta">
						<span className="afs-review__section-ref">{meta}</span>
						<span className="afs-review__section-progress">
							{doneCount}/{totalCount}
						</span>
					</span>
				</div>
				{isExpanded && children}
			</div>
		);
	}
}

export default ToolsReviewSection;
